<template>
	<table class="v-table" v-if="columns.length">
		<thead>
      <compoennt v-for="({header,attrs},index) in columns" :key="index" :width="attrs.width" :is="header(Object.assign(attrs,{index}))"/>
		</thead>
		<tbody>
			<tr v-for="(row,rowIndex) in data" :key="rowIndex">
        <component v-for="({column,value},columnIndex) in columns" :key="`${rowIndex}-${columnIndex}`" :is="column({row,rowIndex,columnIndex})"/>
      </tr>
      <tr class="nodata" v-if="nodata&&!data.length">
        <td :colspan="columns.length">
          <slot name="nodata" v-if="'nodata' in $slots"/>
          <template v-else>{{nodata}}</template>
        </td>
      </tr>
		</tbody>
	</table>
</template>

<script>
export default {
  props: {
    data: {
      default() {
        return [];
      }
    },
    nodata: {
      default: "暂无数据"
    }
  },
  computed: {
    columns() {
      return (this.$slots.default || [])
        .filter(
          o => o.componentOptions && o.componentOptions.tag == "v-table-column"
        )
        .map(o => {
          let { attrs, scopedSlots = {} } = o.data;
          return {
            attrs,
            header: ref => {
              return {
                render: $ => {
                  let slot =
                    "header" in scopedSlots
                      ? scopedSlots.header(ref)
                      : [$("span", ref.label)];
                  return $(
                    "th",
                    (isArray(slot) ? slot : [slot])
                      .reduce((p, o) => p.concat(isArray(o) ? o : [o]), [])
                      .map(o => (o.tag ? o : "\n"))
                  );
                }
              };
            },
            column: ref => {
              return {
                render: $ => {
                  let slot =
                    "default" in scopedSlots
                      ? scopedSlots.default(ref)
                      : [
                          $(
                            "span",
                            attrs.prop ? ref.row[attrs.prop] : attrs.value
                          )
                        ];
                  return $(
                    "td",
                    (isArray(slot) ? slot : [slot])
                      .reduce((p, o) => p.concat(isArray(o) ? o : [o]), [])
                      .map(o => (o.tag ? o : "\n"))
                  );
                }
              };
            }
          };
        });
    }
  }
};
</script>

<style lang="less">
.v-table {
  border-collapse: collapse;
  border: 1px solid #dddddd;
  background-color: #ffffff;
  width: -webkit-fill-available;
  > thead {
    background-color: #eeeeee;
    border-bottom: 1px solid #eeeeee;
    > th {
      text-align: left;
      padding: 8px 10px;
    }
  }
  > tbody {
    border: 1px solid #dddddd;
    > tr {
      border-bottom: 1px solid #eeeeee;
      &:last-child {
        border-bottom: 1px solid #dddddd;
      }
      &.nodata {
        display: none;
        &:first-child {
          display: table-row;
        }
        > td {
          text-align: center;
        }
      }
      > td {
        padding: 8px 10px;
      }
    }
  }
}
</style>
